export const DASHBOARD_BASE_URL = import.meta.env.PROD ? 'dashboard.countercyclical.io' : 'localhost:3000';
export const API_BASE_URL = import.meta.env.PROD ? 'api.countercyclical.io' : 'localhost:8000';

// Layout

export const LEFT_SIDER_DEFAULT_WIDTH = 16 * 20;
export const RIGHT_SIDER_DEFAULT_WIDTH = 16 * 20;

// Query keys

export const WORKSPACE_WATCHLISTS_QUERY_KEY = ['workspace-watchlists'] as const;

const activeWorkspaceQueryScope = (workspaceId?: string) => workspaceId ?? 'active-workspace';

export const workspaceWatchlistsQueryKeys = {
    all: WORKSPACE_WATCHLISTS_QUERY_KEY,
    list: (workspaceId?: string) =>
        [...WORKSPACE_WATCHLISTS_QUERY_KEY, activeWorkspaceQueryScope(workspaceId), 'list'] as const,
    subject: (workspaceId?: string) =>
        [...WORKSPACE_WATCHLISTS_QUERY_KEY, activeWorkspaceQueryScope(workspaceId), 'subject'] as const,
    watchlistSubjects: (workspaceId?: string) =>
        [...WORKSPACE_WATCHLISTS_QUERY_KEY, activeWorkspaceQueryScope(workspaceId), 'watchlist-subjects'] as const,
};

export * from './billing';
export * from './releases';
